import { toast } from "sonner";
import { Loader } from "@/shared/ui/Loader";
import { Modal } from "@/shared/ui/Modal";


import {
  useCreateRewardMutation,
  useRewardQuery,
  useUpdateRewardMutation,
} from "../api/queries";
import { RewardForm } from "./RewardForm";

type RewardFormModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** null = สร้างใหม่, string = แก้ไขตาม id */
  rewardId: string | null;
};

export function RewardFormModal({
  open,
  onOpenChange,
  rewardId,
}: RewardFormModalProps) {
  const isEdit = !!rewardId;
  const { data: reward, isLoading, error } = useRewardQuery(rewardId ?? "");
  const createReward = useCreateRewardMutation();
  const updateReward = useUpdateRewardMutation();
  const submitting =
    createReward.isPending || updateReward.isPending;

  const handleClose = (v: boolean) => {
    if (!v) onOpenChange(false);
  };

  return (
    <Modal
      open={open}
      onOpenChange={handleClose}
      title={isEdit ? "ແກ້ໄຂລາງວັນ" : "ສ້າງລາງວັນ"}
      description={
        isEdit
          ? "ແກ້ໄຂຂໍ້ມູນລາງວັນ"
          : "ຕື່ມຂໍ້ມູນລາງວັນໃໝ່"
      }
      size="md"
      scrollable
    >
      {isEdit && isLoading && !reward ? (
        <div className="flex justify-center py-8">
          <Loader />
        </div>
      ) : isEdit && (error || !reward) ? (
        <p className="py-4 text-sm text-destructive">
          ບໍ່ພົບລາງວັນ
        </p>
      ) : (
        <RewardForm
          defaultValues={
            reward
              ? {
                  name: reward.name,
                  requiredPoints: reward.requiredPoints,
                  variantRewardId: reward.variantRewardId ?? null,
                  imageUrl: reward.imageUrl ?? null,
                  isActive: reward.isActive,
                }
              : undefined
          }
          onSubmit={async (payload) => {
            try {
              if (isEdit && rewardId) {
                await toast.promise(
                  updateReward.mutateAsync({ rewardId, payload }),
                  {
                    loading: "ກຳລັງບັນທຶກ...",
                    success: "ບັນທຶກລາງວັນແລ້ວ",
                    error: "ບັນທຶກລົ້ມເຫຼວ",
                  },
                );
              } else {
                await toast.promise(createReward.mutateAsync(payload), {
                  loading: "ກຳລັງສ້າງລາງວັນ...",
                  success: "ສ້າງລາງວັນສຳເລັດ",
                  error: "ສ້າງລາງວັນລົ້ມເຫຼວ",
                });
              }
              onOpenChange(false);
            } catch {
              // toast from promise
            }
          }}
          submitting={submitting}
          onCancel={() => onOpenChange(false)}
          submitLabel={isEdit ? "ບັນທຶກການປ່ຽນແປງ" : "ສ້າງລາງວັນ"}
        />
      )}
    </Modal>
  );
}
